import { render, staticRenderFns } from "./PopupNotifications.vue?vue&type=template&id=a18af002"
import script from "./PopupNotifications.vue?vue&type=script&lang=js"
export * from "./PopupNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports